import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vueCookies from 'vue-cookies'
import globalFx from './assets/globalFx'
import { createI18n } from 'vue-i18n'
import ko from './locales/ko.json'
import en from './locales/en.json'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light'
  }
})

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: 'ko', // set locale
  fallbackLocale: 'ko', // set fallback locale
  messages: {
    ko,
    en
  }
})

import Particles from "@tsparticles/vue3";

const app = createApp(App)
app.use(vuetify)
app.use(router)
app.use(vueCookies)
app.use(globalFx)
app.use(Particles)
app.use(i18n)

router.beforeEach((to, from, next) => {
  const lang = to.params.lang || to.meta.defaultLanguage || 'ko';
  if (i18n.global.locale !== lang) {
    i18n.global.locale = lang;
  }
  next();
});

app.mount('#app')
